export * from './screening-confirmation-page.component';
